// src/hooks/usePagination.ts

import { useState, useCallback } from 'react';

/**
 * 分页状态管理 Hook
 * 管理当前页码、每页数量和分页操作
 */
export const usePagination = (initialPage: number = 1, initialSize: number = 20) => {
  const [page, setPage] = useState<number>(initialPage);
  const [size, setSize] = useState<number>(initialSize);

  /**
   * 设置新的页码
   * @param newPage - 新的页码（必须 >= 1）
   */
  const setPageNumber = useCallback((newPage: number): void => {
    if (newPage < 1) {
      console.warn('Page number must be at least 1');
      return;
    }
    setPage(newPage);
  }, []);

  /**
   * 设置每页数量
   * @param newSize - 每页数量（必须 >= 1）
   */
  const setPageSize = useCallback((newSize: number): void => {
    if (newSize < 1) {
      console.warn('Page size must be at least 1');
      return;
    }
    setSize(newSize);
    setPage(1); // 重置到第一页
  }, []);

  /**
   * 跳转到下一页
   */
  const nextPage = useCallback((): void => {
    setPage((prev) => prev + 1);
  }, []);

  /**
   * 跳转到上一页
   */
  const prevPage = useCallback((): void => {
    setPage((prev) => Math.max(1, prev - 1));
  }, []);

  /**
   * 重置分页到初始状态
   */
  const resetPagination = useCallback((): void => {
    setPage(initialPage);
    setSize(initialSize);
  }, [initialPage, initialSize]);

  return {
    page,
    size,
    setPage: setPageNumber,
    setPageSize,
    nextPage,
    prevPage,
    resetPagination,
  };
};